import Text from 'components/Text/Text';
import React, { useContext, useEffect, useRef } from 'react';
import { IRestaurantLocalizationGroup } from 'types';
import LocalizationItem from './components/LocalizationItem';
import { ILocalizationContext, LocalizationContext } from '../../../../../../localizationState/localizationContext';
import style from './LocalizationGroup.module.scss';

interface ILocalizationGroup {
	languageId: string;
	groupData: IRestaurantLocalizationGroup;
}

const LocalizationGroup: React.FC<ILocalizationGroup> = ({ languageId, groupData }) => {
	const { selectedGroup, selectedLanguage } = useContext<ILocalizationContext>(LocalizationContext);
	const headingElement = useRef<HTMLDivElement | null>(null);

	useEffect(() => {
		if (selectedGroup?.id === groupData.id && selectedLanguage?.id === languageId) {
			headingElement.current?.scrollIntoView({ behavior: 'smooth' });
		}
	}, [selectedGroup]);

	return (
		<div className={style.container}>
			<div className={style.heading} ref={headingElement}>
				<Text
					className={style.heading}
					translationNameSpace="localizationSettings"
					translationKey={groupData.name}
					theme="secondary"
					size="l"
					weight="bold"
					display="inline"
				/>
			</div>
			<div className={style.items}>
				{groupData.items.map((el) => (
					<LocalizationItem key={el.key} groupId={groupData.id || ''} itemData={el} languageId={languageId} />
				))}
			</div>
		</div>
	);
};

export default LocalizationGroup;
